var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F5F8FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6024_33698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 21C20.6025 21 24.3333 16 24.3333 16C24.3333 16 20.6025 11 16 11C11.3975 11 7.66663 16 7.66663 16C7.66663 16 11.3975 21 16 21Z",
    stroke: "#8898A6",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18.0832C16.5525 18.0832 17.0824 17.8637 17.4731 17.473C17.8638 17.0823 18.0833 16.5524 18.0833 15.9998C18.0833 15.4473 17.8638 14.9174 17.4731 14.5267C17.0824 14.136 16.5525 13.9165 16 13.9165C15.4474 13.9165 14.9175 14.136 14.5268 14.5267C14.1361 14.9174 13.9166 15.4473 13.9166 15.9998C13.9166 16.5524 14.1361 17.0823 14.5268 17.473C14.9175 17.8637 15.4474 18.0832 16 18.0832Z",
    stroke: "#8898A6",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6024_33698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcView);
export default __webpack_public_path__ + "static/media/ic-view.5cc1e5c8d613807dfeef0f9cf689d9e7.svg";
export { ForwardRef as ReactComponent };